module.exports = __webpack_public_path__ + "static/media/branding-image-1.08ca5ceb.png";